import { FlowBuilderService } from '@hubtype/data-access-api'
import {
  HubtypeFlow,
  HubtypeFlowBuilderData,
} from '@hubtype/data-access-models'

import { CMSWriter } from '../../domain/models/cms'
import { DRAFT_VERSION, MAIN_FLOW } from '../../UI/constants'
import { State } from '../../UI/types'
import { isWebview } from '../../webviews/utils'
import { getHash } from '../hash-utils'
import { HtFlowFactory } from './ht-flow-factory'
import { NodeFactory } from './hubtype-node-factory'

export class HubtypeWriter implements CMSWriter {
  private nodeFactory
  constructor(private readonly flowBuilderService: FlowBuilderService) {
    this.nodeFactory = new NodeFactory()
  }

  async writeContent(state: State): Promise<string> {
    const flows = HtFlowFactory.getFlows(state)
    const startNodeId = this.getStartNodeId(flows)

    const { hubtypeNodes, webviewContent } =
      this.nodeFactory.getHubtypeNodes(state)

    const flowData: HubtypeFlowBuilderData = {
      version: DRAFT_VERSION,
      name: 'Test data',
      locales: this.getLocales(state),
      hash: '',
      nodes: hubtypeNodes,
      is_knowledge_base_active: state.isKnowledgeBaseActive,
      bot_variables: state.botVariables,
      start_node_id: startNodeId,
      flows,
      webviews: state.flows
        .filter(flow => isWebview(flow.id))
        .map(flow => ({ name: flow.name, id: flow.id.split('_')[1] })),
      webview_contents: webviewContent,
    }
    const newHash = await getHash(structuredClone(flowData))
    flowData.hash = newHash
    await this.flowBuilderService.saveFlow(
      flowData,
      state.organizationContents.currentBot.id
    )
    return newHash
  }

  private getLocales(state: State) {
    const currentLocaleCode = state.currentLocale.code
    return [
      currentLocaleCode,
      ...state.locales
        .filter(locale => locale.code !== currentLocaleCode)
        .map(locale => locale.code),
    ]
  }

  private getStartNodeId = (flows: HubtypeFlow[]): string | undefined => {
    return flows.find(flow => flow.id === MAIN_FLOW.id)?.start_node_id
  }
}
